import { notify } from 'utils/reduxUtils';

export const types = {
  CREATE_STRIPE_ACCOUNT_ERROR:
    'settings/bankingInformation/CREATE_STRIPE_ACCOUNT_ERROR',
  CREATE_STRIPE_ACCOUNT_REQUEST:
    'settings/bankingInformation/CREATE_STRIPE_ACCOUNT_REQUEST',
  CREATE_STRIPE_ACCOUNT_SUCCESS:
    'settings/bankingInformation/CREATE_STRIPE_ACCOUNT_SUCCESS',
  GET_STRIPE_ONBOARDING_LINK_ERROR:
    'settings/bankingInformation/GET_STRIPE_ONBOARDING_LINK_ERROR',
  GET_STRIPE_ONBOARDING_LINK_REQUEST:
    'settings/bankingInformation/GET_STRIPE_ONBOARDING_LINK_REQUEST',
  GET_STRIPE_ONBOARDING_LINK_SUCCESS:
    'settings/bankingInformation/GET_STRIPE_ONBOARDING_LINK_SUCCESS',
  STRIPE_ONBOARDING_ERROR:
    'settings/bankingInformation/STRIPE_ONBOARDING_ERROR',
  STRIPE_ONBOARDING_SUCCESS:
    'settings/bankingInformation/STRIPE_ONBOARDING_SUCCESS',

  UPDATE_CREDIT_CARD_CHECKOUT_REQUEST:
    'settings/bankingInformation/UPDATE_CREDIT_CARD_CHECKOUT_REQUEST',
  UPDATE_CREDIT_CARD_CHECKOUT_SUCCESS:
    'settings/bankingInformation/UPDATE_CREDIT_CARD_CHECKOUT_SUCCESS',
  UPDATE_CREDIT_CARD_CHECKOUT_ERROR:
    'settings/bankingInformation/UPDATE_CREDIT_CARD_CHECKOUT_ERROR',
};

export const createStripeAccount = {
  error: notify(
    (error) => ({
      type: types.CREATE_STRIPE_ACCOUNT_ERROR,
      payload: error,
    }),
    "Can't create stripe account.",
  ),
  request: () => ({
    type: types.CREATE_STRIPE_ACCOUNT_REQUEST,
  }),
  success: () => ({
    type: types.CREATE_STRIPE_ACCOUNT_SUCCESS,
  }),
};

export const getOnBoardingLink = {
  error: notify(
    (error) => ({
      type: types.GET_STRIPE_ONBOARDING_LINK_ERROR,
      payload: error,
    }),
    "Can't get stripe onboarding link.",
  ),
  request: () => ({
    type: types.GET_STRIPE_ONBOARDING_LINK_REQUEST,
  }),
  success: () => ({
    type: types.GET_STRIPE_ONBOARDING_LINK_SUCCESS,
  }),
};

export const stripeOnboarding = {
  error: notify(
    (error) => ({
      type: types.STRIPE_ONBOARDING_ERROR,
      payload: error,
    }),
    'Failed to set stripe information.',
  ),
  success: notify(
    () => ({
      type: types.STRIPE_ONBOARDING_SUCCESS,
    }),
    'Stripe information set successfully.',
  ),
};

export const updateCreditCardCheckout = {
  error: notify(
    ({ creditCardCheckout }) => ({
      type: types.UPDATE_CREDIT_CARD_CHECKOUT_ERROR,
      payload: {
        creditCardCheckout,
      },
    }),
    ({ payload }) =>
      `Error ${
        payload?.creditCardCheckout ? 'enabling' : 'disabling'
      } credit card checkout.`,
  ),
  request: ({ creditCardCheckout }) => ({
    type: types.UPDATE_CREDIT_CARD_CHECKOUT_REQUEST,
    payload: {
      creditCardCheckout,
    },
  }),
  success: notify(
    ({ creditCardCheckout }) => ({
      type: types.UPDATE_CREDIT_CARD_CHECKOUT_SUCCESS,
      payload: {
        creditCardCheckout,
      },
    }),
    ({ payload }) =>
      payload?.creditCardCheckout
        ? 'Successfully enabled credit card checkout.'
        : 'Disabled credit card checkout.',
  ),
};
